import React, { createContext, useContext, useMemo, useState } from 'react';

const PeEmbedContext = createContext(false);

/** True when PE runs inside Super Picker's Marketing Materials iframe (`?embed=1` or in iframe). */
export function detectPeEmbedMode(): boolean {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('embed') === '1' || params.get('embed') === 'true') {
      return true;
    }
  } catch {
    // ignore
  }
  try {
    return window.self !== window.top;
  } catch {
    // Cross-origin parent access throws — treat as embedded.
    return true;
  }
}

export function PeEmbedProvider({ children }: { children: React.ReactNode }) {
  // Capture once for this PE app instance so client-side navigations keep
  // embed chrome even after ?embed= is dropped from the URL.
  const [isEmbed] = useState(detectPeEmbedMode);
  const value = useMemo(() => isEmbed, [isEmbed]);
  return <PeEmbedContext.Provider value={value}>{children}</PeEmbedContext.Provider>;
}

export function usePeEmbed(): boolean {
  return useContext(PeEmbedContext);
}
